import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import { json } from '@newtontechnologies/beey-api-js-client/receivers';
import { createProjectFromApi } from './model/project';
export const enqueue = (connection, projectId, language, transcriptionProfile = 'default', withPPC = true, withVAD = true, withDiarization = true, withUserLex = true, saveTrsx = true, withSpeakerId = true, withDraft = false, allowEmptyTranscription = false) => connection.fetch()
    .url(apiV2.projects.id(projectId).enqueue.url({
    projectId,
    lang: language.code,
    withPPC,
    withVAD,
    saveTrsx,
    transcriptionProfile,
    withSpeakerId,
    withDiarization,
    withUserLex,
    withDraft,
    allowEmptyTranscription,
}))
    .receive(json()
    .map(createProjectFromApi)
    .catchHttpError((response) => {
    switch (response.status) {
        case 403:
            return { error: 'forbidden' };
        case 412:
            return { error: 'precondition-failed' };
        case 422:
            return { error: 'invalid-data' };
        default:
            return 'unknown';
    }
})
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchQueuedProjectsIds = (connection) => connection.fetch()
    .url(apiV2.projects.queue.url())
    .receive(json()
    .map((data) => data.ids))
    .fetch();
